
(function( $ ){
    $.fn.tlawDonorGallery = function() {
        //Set Up Gallery
        $donorGallery = $(this);
        $nextButton = $('<button class="btn btn-muted" aria-controls="donor-list" aria-label="Next Page"><i class="fas fa-angle-down"></i></button>');
        $previousButton = $('<button class="btn btn-muted" aria-controls="donor-list" aria-label="Previous Page"><i class="fas fa-angle-up"></i></button>');
        $donorGalleryButtons = $('<div></div>');
        $donorGalleryList = $('<ul class="donor-gallery__donors" id="donor-list">');
        $searchField = $('<input class="form-control donor-gallery__search" aria-controls="donor-list" type="text" placeholder="Search Donors"></input>');

        $donorGallery.html("<span class=\"alert alert-info\">No donors found for this campaign.</span>");

        var gallery = {
            campaignId : parseInt($(this).attr('data-campaign-id')),
            itemsPerPage : parseInt($(this).attr('data-items-per-page')),
            currentPage : 0,
            searchQuery : null,
            allDonorNames : [],
            queriedDonorNames : [],
            currentPageDonorNames : [],
        };

        var loadPage = function(page) {
            var pageStartIndex;
            var pageEndIndex;

            pageStartIndex = (page - 1) * gallery.itemsPerPage;
            pageEndIndex = pageStartIndex + gallery.itemsPerPage;
            gallery.currentPageDonorNames = gallery.queriedDonorNames.slice(pageStartIndex, pageEndIndex);
            gallery.currentPage = page;
        };

        var updateGalleryList = function() {
            $donorGalleryList.empty();

            if(gallery.currentPageDonorNames.length > 0) {
                gallery.currentPageDonorNames.forEach(function(name) {
                    $donorGalleryList.append('<li class="donor-gallery__donor"><span class="donor-gallery__donor-icon"><i class="fas fa-user"></i></span>' + name + '</li>');
                });
            }
            else {
                $donorGalleryList.append('No matching donors were found.');
            }

            //disable previous button if on first page
            if(gallery.currentPage == 1) {
                $previousButton.prop('disabled', true);
            }
            else {
                $previousButton.prop('disabled', false);
            }

            //disable next button if on last page
            if(gallery.currentPage >= Math.ceil(gallery.queriedDonorNames.length / gallery.itemsPerPage)) {
                $nextButton.prop('disabled', true);
            }
            else {
                $nextButton.prop('disabled', false);
            }
        }

        var nextPage = function() {
            if(gallery.currentPage >= Math.ceil(gallery.queriedDonorNames.length / gallery.itemsPerPage)) {
                return; //already on last page
            }

            loadPage(gallery.currentPage + 1);
            updateGalleryList();
        }

        var previousPage = function() {
            if(gallery.currentPage == 1) {
                return; //already on first page
            }
            loadPage(gallery.currentPage - 1);
            updateGalleryList();
        }

        var searchDonors = function(query) {
            gallery.queriedDonorNames = gallery.allDonorNames.filter(function(name) {
                return name.toLowerCase().includes(query.trim().toLowerCase());
            });

            initializeGalleryList();
        }

        var clearSearch = function() {
            gallery.queriedDonorNames = gallery.allDonorNames;

            initializeGalleryList();
        }

        var initializeGalleryList = function() {
            loadPage(1);
            updateGalleryList();
        }

        var loadCampaignData = function() {
            $.ajax({
                url: WP_AJAX.WP_JSON_CAMPAIGN_ENDPOINT + $donorGallery.data('campaignId'),
                data: {
                    _fields: 'donor_names'
                },
                cache: false,
                beforeSend: function(){
                    $donorGallery.empty();
                    $nextButton.unbind('click', nextPage);
                    $previousButton.unbind('click', previousPage);

                    $donorGallery.html('<div class="donor-gallery__loading">Loading...</div>');
                },
                complete: function(){
                    
                },
                success: function(data){
                    gallery.allDonorNames = data.donor_names;
                    gallery.queriedDonorNames = gallery.allDonorNames;
    
                    //add the  the list and buttons
                    $donorGallery.empty();
                    $donorGallery.append($searchField);
                    $donorGallery.append($donorGalleryList);
                    $donorGalleryButtons.append($previousButton);
                    $donorGalleryButtons.append($nextButton);
                    $donorGallery.append($donorGalleryButtons);

                    //load the first page and update gallery list
                    initializeGalleryList();

                    $searchField.on('input', function() {
                        searchDonors($(this).val());
                    });
                    $nextButton.bind('click', nextPage);
                    $previousButton.bind('click', previousPage);

                }
            });
        }

        loadCampaignData();
                
       return this;
    }; 
 })( jQuery );

 let donor_gallery = jQuery('.js-donor-gallery')
 
 if (donor_gallery.length > 0) {
    donor_gallery.tlawDonorGallery();
 }
